import { useLocation } from 'react-router-dom';
import { Construction } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { NAV_SECTIONS } from '@/constants/navigation';
import type { NavItem } from '@/constants/navigation';

function findPageLabel(sections: NavItem[], pathname: string): string {
  for (const s of sections) {
    if (s.path === pathname) return s.label;
    for (const c of s.children ?? []) {
      if (c.path === pathname) return c.label;
    }
  }
  return 'This Page';
}

export const PlaceholderPage = () => {
  const { pathname } = useLocation();
  const label = findPageLabel(NAV_SECTIONS, pathname);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full text-center py-12 px-8">
        <div className="w-16 h-16 rounded-full bg-amber-50 dark:bg-amber-900/20 flex items-center justify-center mx-auto mb-4">
          <Construction size={28} className="text-amber-500" />
        </div>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
          {label}
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">
          This screen is not available yet.
        </p>
        <p className="text-xs text-gray-400 dark:text-gray-500">
          Contact your administrator if you need it — nothing here is missing from your data.
        </p>
      </Card>
    </div>
  );
};
